import { Context } from '@vue-storefront/core';
import {ApiResult} from '../../types';

export default async function customAddReview(context: Context, review: any): Promise<ApiResult> {
  const url = new URL('/mall/review/add', context.config.api.url);
  // return false;
  const newReview = {
    review_id: review.reviewId,
    order_id: review.orderId,
    goods_id: review.goodsId,
    sku_id: review.skuId,
    grade: review.grade,
    review_content: review.reviewContent,
    image_url1: '',
    image_url2: '',
    image_url3: '',
    image_url4: '',
    image_url5: '',
    video_url: review.videoUrl
  };
  if (review.images && review.images.length) {
    review.images.map((image, index) => {
      newReview[`image_url${(index + 1)}`] = image;
    });
  }
  const { data: res } = await context.client.post(url.href, newReview);
  return res;
}
